import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
var _newNote, _newPrivateNote, _notes, _reduceMap;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import createReducer, { objectActionHandler } from "../../util/create_reducer";
import { APPLICATION_SET_ADVISOR_ACTION, APPLICATION_SET_APPLICATION_ACTION, APPLICATION_SET_DATES_ACTION, APPLICATION_SET_ID_ACTION, APPLICATION_SET_OTHER_APPLICATIONS_ACTION, APPLICATION_SET_OTHER_APPLICATIONS_LOADED_ACTION, APPLICATION_SET_OTHER_APPLICATIONS_LOADING_ACTION, APPLICATION_SET_PERMISSIONS_ACTION, APPLICATION_SET_PREVIEW_REQUIREMENT_FILE_ID_ACTION, APPLICATION_SET_PREVIEW_REQUIREMENT_ID_ACTION, APPLICATION_SET_PROGRAM_ACTION, APPLICATION_SET_PROGRAM_ESL_ACTION, APPLICATION_SET_REQUIREMENTS_LOADING_ACTION, APPLICATION_SET_ROWLOADING_ACTION, APPLICATION_SET_SCHOOL_ACTION, APPLICATION_SET_STATUS_ACTION, APPLICATION_SET_CANCEL_STATUS_ACTION, APPLICATION_SET_CANCELLATION_REASON_ACTION, APPLICATION_SET_CANCELLATION_ADDITIONAL_NOTE_ACTION, APPLICATION_SET_STUDENT_PROFILE_ACTION, APPLICATION_SET_TAB_ACTION, APPLICATION_SET_CREATE_REQUIREMENT_ACTION, APPLICATION_SET_META_ACTION, SHOW_REQ_COUNT_ACTION, HIDE_REQ_COUNT_ACTION, SET_APP_REQ_COUNT, SET_ACTIONS_COUNT, APPLICATION_SET_EDIT_REQUIREMENT_ACTION, APPLICATION_CLEAR_EDIT_REQUIREMENT_ACTION, IS_INITIAL_ACTUAL_START_DATES_ACTION, SAVED_PROGRAM_INTAKE_START_DATE_ACTION, NOTES_ADD_FILE_NEW_NOTE_ACTION, NOTES_ADD_FILE_NEW_PRIVATE_NOTE_ACTION, NOTES_CLEAR_FILES_NEW_NOTE_ACTION, NOTES_CLEAR_FILES_NEW_PRIVATE_NOTE_ACTION, NOTES_DELETE_ACTION, NOTES_INSERT_ACTION, NOTES_RECEIVED_ACTION, NOTES_REMOVE_FILE_NEW_NOTE_ACTION, NOTES_REMOVE_FILE_NEW_PRIVATE_NOTE_ACTION, NOTES_SET_ADDING_ACTION, NOTES_SET_ADDING_PRIVATE_ACTION, NOTES_SET_LOADING_ACTION, NOTES_SET_NEW_NOTE_LOADING_ACTION, NOTES_SET_NEW_PRIVATE_NOTE_LOADING_ACTION, NOTES_SET_WITH_ALERT_ONLY_ACTION, NOTES_UPDATE_NEW_NOTE_ACTION, NOTES_UPDATE_NEW_PRIVATE_NOTE_ACTION } from "../actions/application";
var emptyNote = {
  title: null,
  body: null,
  dirty: false,
  files: [],
  templateId: null,
  email_user: true,
  restricted: false
};
export var defaultState = {
  loading: false,
  rowloading: {},
  notes: {
    filter: 'all',
    availableIndexes: [],
    byIndex: {},
    withAlertOnly: false,
    // NewNote
    addingNote: false,
    newNote: _objectSpread({
      visibility: 'public'
    }, emptyNote),
    newNoteLoading: null,
    // NewPrivateNote
    addingPrivateNote: false,
    newPrivateNote: _objectSpread({
      visibility: 'private'
    }, emptyNote),
    newPrivateNoteLoading: null
  },
  // TODO: this can probably be removed but we need to double check
  requirements: {
    byIndex: {},
    availableIndexes: [],
    loading: false
  },
  otherApplications: {
    byIndex: {},
    availableIndexes: [],
    loading: false,
    loaded: false
  },
  currentTab: 'Applicant Requirements',
  applicationId: null,
  permissions: {},
  application: null,
  sidebarExpanded: true,
  editing_requirement_id: null,
  creating_requirement: false,
  showAppReqCount: false,
  showActionsCount: false,
  actionsCount: 0,
  appReqCount: 0,
  isInitialActualStartDates: true,
  savedProgramIntakeStartDate: null
};
export var setIsInitialActualStartDates = function setIsInitialActualStartDates(state, action) {
  return {
    isInitialActualStartDates: action.value
  };
};
export var setSavedProgramIntakeStartDate = function setSavedProgramIntakeStartDate(state, action) {
  return {
    savedProgramIntakeStartDate: action.value
  };
};
export var applicationSetId = function applicationSetId(state, action) {
  return {
    applicationId: action.value
  };
};
export var applicationSetPermissions = function applicationSetPermissions(state, action) {
  return {
    permissions: action.value
  };
};
export var applicationSetApplication = function applicationSetApplication(state, action) {
  return {
    savedProgramIntakeStartDate: action.value.intake,
    application: _objectSpread(_objectSpread({}, state.application), action.value)
  };
};
export var applicationSetStudentProfile = function applicationSetStudentProfile(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      student: _objectSpread({
        student_link: action.value.link
      }, action.value.profile)
    })
  };
};
export var applicationSetOtherApplicationsLoading = function applicationSetOtherApplicationsLoading(state, _ref) {
  var value = _ref.value;
  return {
    otherApplications: _objectSpread(_objectSpread({}, state.otherApplications), {}, {
      loading: value
    })
  };
};
export var applicationSetOtherApplicationsLoaded = function applicationSetOtherApplicationsLoaded(state, _ref2) {
  var value = _ref2.value;
  return {
    otherApplications: _objectSpread(_objectSpread({}, state.otherApplications), {}, {
      loaded: value
    })
  };
};
export var applicationSetOtherApplications = function applicationSetOtherApplications(state, _ref3) {
  var value = _ref3.value;
  return {
    otherApplications: _objectSpread(_objectSpread({}, state.otherApplications), {}, {
      availableIndexes: value.map(function (entry) {
        return entry.id;
      }),
      byIndex: value.reduce(function (response, entry) {
        return _objectSpread(_objectSpread({}, response), {}, _defineProperty({}, entry.id, entry));
      }, {})
    })
  };
};
var applicationSetSchool = function applicationSetSchool(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      school: action.value
    })
  };
};
var applicationSetProgram = function applicationSetProgram(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      program: action.value
    })
  };
};
var applicationSetProgramEsl = function applicationSetProgramEsl(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      program_esl: action.value
    })
  };
};
var applicationSetAdvisor = function applicationSetAdvisor(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      advisor: action.value
    })
  };
};
var applicationSetStatus = function applicationSetStatus(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      status: action.value
    })
  };
};
var applicationSetCancelStatus = function applicationSetCancelStatus(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      status: _objectSpread(_objectSpread({}, state.application.status), action.value)
    })
  };
};
var applicationSetCancellationReason = function applicationSetCancellationReason(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      cancellation_reason_id: action.value.cancelReasonId,
      cancellation_reason: action.value.cancelReasonLabel
    })
  };
};
var applicationSetCancellationAdditionalNote = function applicationSetCancellationAdditionalNote(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      cancellation_additional_note: action.value
    })
  };
};
var applicationSetDates = function applicationSetDates(state, _ref4) {
  var dateId = _ref4.dateId,
    date = _ref4.date,
    eslDateId = _ref4.eslDateId,
    eslDate = _ref4.eslDate,
    eslActualStartDate = _ref4.eslActualStartDate,
    programActualStartDate = _ref4.programActualStartDate,
    eslAlternateActualStartDate = _ref4.eslAlternateActualStartDate,
    programAlternateActualStartDate = _ref4.programAlternateActualStartDate;
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      mainIntakeId: dateId,
      intake: date,
      eslIntakeId: eslDateId,
      intake_esl: eslDate,
      esl_actual_start_date: eslActualStartDate,
      program_actual_start_date: programActualStartDate,
      esl_alternate_actual_start_date: eslAlternateActualStartDate,
      program_alternate_actual_start_date: programAlternateActualStartDate
    })
  };
};
var applicationSetMeta = function applicationSetMeta(state, action) {
  return {
    application: _objectSpread(_objectSpread({}, state.application), {}, {
      meta: action.value
    })
  };
};
export var reducerSetLoading = function reducerSetLoading(state, action) {
  return {
    loading: action.value
  };
};
export var applicationSetRowLoading = function applicationSetRowLoading(state, _ref5) {
  var name = _ref5.name,
    value = _ref5.value;
  return {
    rowloading: _objectSpread(_objectSpread({}, state.rowloading), {}, _defineProperty({}, name, value))
  };
};
export var applicationSetCurrentTab = function applicationSetCurrentTab(state, action) {
  return {
    currentTab: action.value
  };
};
export var applicationSetRequirementsLoading = function applicationSetRequirementsLoading(state, action) {
  return {
    requirements: _objectSpread(_objectSpread({}, state.requirements), {}, {
      loading: action.value
    })
  };
};
export var applicationSetPreviewRequirementId = function applicationSetPreviewRequirementId(state, action) {
  return {
    selectedPreviewRequirementId: action.id,
    selectedPreviewRequirementFileId: action.fileId
  };
};
export var applicationSetPreviewRequirementFileId = function applicationSetPreviewRequirementFileId(state, action) {
  return {
    selectedPreviewRequirementFileId: action.value
  };
};
export var notesReceived = function notesReceived(state, action) {
  var returnValue = {
    availableIndexes: [],
    byIndex: {}
  };
  action.value.forEach(function (entry) {
    returnValue.availableIndexes.push(entry.id);
    returnValue.byIndex[entry.id] = entry;
  });
  return returnValue;
};
export var notesSetWithAlertOnly = function notesSetWithAlertOnly(state, _ref6) {
  var value = _ref6.value;
  return {
    withAlertOnly: value
  };
};
export var deleteNote = function deleteNote(_ref7, _ref8) {
  var byIndex = _ref7.byIndex,
    availableIndexes = _ref7.availableIndexes;
  var value = _ref8.value;
  var returnValue = {
    byIndex: {},
    availableIndexes: []
  };
  var noteId = value;
  returnValue.availableIndexes = availableIndexes.filter(function (entry) {
    return entry !== noteId;
  });
  returnValue.availableIndexes.forEach(function (idx) {
    returnValue.byIndex[idx] = byIndex[idx];
  });
  return returnValue;
};
export var insertNote = function insertNote(_ref9, _ref10) {
  var availableIndexes = _ref9.availableIndexes,
    byIndex = _ref9.byIndex;
  var value = _ref10.value;
  return {
    availableIndexes: [value.id].concat(_toConsumableArray(availableIndexes)),
    byIndex: _objectSpread(_objectSpread({}, byIndex), {}, _defineProperty({}, value.id, value))
  };
};
export var notesSetAdding = function notesSetAdding(state, _ref11) {
  var adding = _ref11.adding,
    clear = _ref11.clear,
    visibility = _ref11.visibility;
  var returnValue = {
    addingNote: adding,
    newNote: state.newNote
  };
  if (clear) {
    returnValue.newNote = _objectSpread({}, emptyNote);
  }
  if (visibility) {
    returnValue.newNote.visibility = visibility;
  }
  return returnValue;
};
export var notesSetAddingPrivate = function notesSetAddingPrivate(state, _ref12) {
  var adding = _ref12.adding,
    clear = _ref12.clear,
    visibility = _ref12.visibility;
  var returnValue = {
    addingPrivateNote: adding,
    newPrivateNote: state.newPrivateNote
  };
  if (clear) {
    returnValue.newPrivateNote = _objectSpread({}, emptyNote);
  }
  if (visibility) {
    returnValue.newPrivateNote.visibility = visibility;
  }
  return returnValue;
};
export var updateNewNote = function updateNewNote(state, action) {
  var newNote = _objectSpread({}, state);
  if (action.value == null) {
    newNote.dirty = false;
    newNote.title = null;
    newNote.body = null;
    newNote.files = [];
    newNote.templateId = null;
    newNote.email_user = true;
    newNote.restricted = false;
    return newNote;
  }
  var dirty = state.dirty;
  if (action.value.dirty != null) {
    dirty = action.value.dirty;
  } else if (action.value.title && action.value.title !== state.title) {
    dirty = true;
  } else if (action.value.body && action.value.body !== state.body) {
    // this is a hack because quill automatically removes the last line
    // if it is empty. If we don't check like this, dirty will be set to false
    // and then immediately set to true
    if ("".concat(action.value.body, "<p><br></p>") !== state.body) {
      dirty = true;
    }
  }
  newNote = _objectSpread(_objectSpread(_objectSpread({}, state), action.value), {}, {
    dirty: dirty
  });
  if (Object.prototype.hasOwnProperty.call(action.value, 'title') && newNote.title === null) {
    newNote.title = '';
  }
  return newNote;
};
export var setNewNoteLoading = function setNewNoteLoading(state, action) {
  return {
    newNoteLoading: action.value
  };
};
export var setNewPrivateNoteLoading = function setNewPrivateNoteLoading(state, action) {
  return {
    newPrivateNoteLoading: action.value
  };
};
export var addFileNewNote = function addFileNewNote(state, action) {
  return updateNewNote(state, {
    value: {
      files: [].concat(_toConsumableArray(state.files), [action.value])
    }
  });
};
export var removeFileNewNote = function removeFileNewNote(state, action) {
  var files = state.files || [];
  return updateNewNote(state, {
    value: {
      files: files.filter(function (file, index) {
        return index !== action.value;
      })
    }
  });
};
export var clearFilesNewNote = function clearFilesNewNote(state) {
  return updateNewNote(state, {
    value: {
      files: []
    }
  });
};
export var applicationSetCreateRequirement = function applicationSetCreateRequirement(state) {
  if (state.creating_requirement) return;

  // eslint-disable-next-line consistent-return
  return {
    creating_requirement: true
  };
};
export var showReqCount = function showReqCount() {
  return {
    showActionsCount: true,
    showAppReqCount: true
  };
};
export var hideReqCount = function hideReqCount(state, action) {
  if (action.value == 'actions') {
    return {
      showActionsCount: false
    };
  } else {
    return {
      showAppReqCount: false
    };
  }
};
export var setActionsCount = function setActionsCount(state, action) {
  return {
    actionsCount: action.value
  };
};
export var setAppReqCount = function setAppReqCount(state, action) {
  return {
    appReqCount: action.value
  };
};
export var applicationSetRequirement = function applicationSetRequirement(state, action) {
  if (action.value === state.editing_requirement_id) return null;
  return {
    editing_requirement_id: action.value
  };
};
export var applicationClearRequirement = function applicationClearRequirement(state) {
  if (!state.editing_requirement_id && !state.creating_requirement) return null;
  return {
    editing_requirement_id: null,
    creating_requirement: false
  };
};
var reduceMap = (_reduceMap = {}, _defineProperty(_reduceMap, APPLICATION_SET_ADVISOR_ACTION, applicationSetAdvisor), _defineProperty(_reduceMap, APPLICATION_SET_APPLICATION_ACTION, applicationSetApplication), _defineProperty(_reduceMap, APPLICATION_SET_DATES_ACTION, applicationSetDates), _defineProperty(_reduceMap, APPLICATION_SET_ID_ACTION, applicationSetId), _defineProperty(_reduceMap, APPLICATION_SET_OTHER_APPLICATIONS_ACTION, applicationSetOtherApplications), _defineProperty(_reduceMap, APPLICATION_SET_OTHER_APPLICATIONS_LOADED_ACTION, applicationSetOtherApplicationsLoaded), _defineProperty(_reduceMap, APPLICATION_SET_OTHER_APPLICATIONS_LOADING_ACTION, applicationSetOtherApplicationsLoading), _defineProperty(_reduceMap, APPLICATION_SET_PERMISSIONS_ACTION, applicationSetPermissions), _defineProperty(_reduceMap, APPLICATION_SET_PROGRAM_ACTION, applicationSetProgram), _defineProperty(_reduceMap, APPLICATION_SET_PROGRAM_ESL_ACTION, applicationSetProgramEsl), _defineProperty(_reduceMap, APPLICATION_SET_REQUIREMENTS_LOADING_ACTION, applicationSetRequirementsLoading), _defineProperty(_reduceMap, APPLICATION_SET_ROWLOADING_ACTION, applicationSetRowLoading), _defineProperty(_reduceMap, APPLICATION_SET_SCHOOL_ACTION, applicationSetSchool), _defineProperty(_reduceMap, APPLICATION_SET_STATUS_ACTION, applicationSetStatus), _defineProperty(_reduceMap, APPLICATION_SET_CANCEL_STATUS_ACTION, applicationSetCancelStatus), _defineProperty(_reduceMap, APPLICATION_SET_CANCELLATION_REASON_ACTION, applicationSetCancellationReason), _defineProperty(_reduceMap, APPLICATION_SET_CANCELLATION_ADDITIONAL_NOTE_ACTION, applicationSetCancellationAdditionalNote), _defineProperty(_reduceMap, APPLICATION_SET_STUDENT_PROFILE_ACTION, applicationSetStudentProfile), _defineProperty(_reduceMap, APPLICATION_SET_TAB_ACTION, applicationSetCurrentTab), _defineProperty(_reduceMap, APPLICATION_SET_PREVIEW_REQUIREMENT_ID_ACTION, applicationSetPreviewRequirementId), _defineProperty(_reduceMap, APPLICATION_SET_PREVIEW_REQUIREMENT_FILE_ID_ACTION, applicationSetPreviewRequirementFileId), _defineProperty(_reduceMap, APPLICATION_SET_CREATE_REQUIREMENT_ACTION, applicationSetCreateRequirement), _defineProperty(_reduceMap, APPLICATION_SET_META_ACTION, applicationSetMeta), _defineProperty(_reduceMap, SHOW_REQ_COUNT_ACTION, showReqCount), _defineProperty(_reduceMap, HIDE_REQ_COUNT_ACTION, hideReqCount), _defineProperty(_reduceMap, SET_APP_REQ_COUNT, setAppReqCount), _defineProperty(_reduceMap, SET_ACTIONS_COUNT, setActionsCount), _defineProperty(_reduceMap, APPLICATION_SET_EDIT_REQUIREMENT_ACTION, applicationSetRequirement), _defineProperty(_reduceMap, APPLICATION_CLEAR_EDIT_REQUIREMENT_ACTION, applicationClearRequirement), _defineProperty(_reduceMap, IS_INITIAL_ACTUAL_START_DATES_ACTION, setIsInitialActualStartDates), _defineProperty(_reduceMap, SAVED_PROGRAM_INTAKE_START_DATE_ACTION, setSavedProgramIntakeStartDate), _defineProperty(_reduceMap, NOTES_SET_LOADING_ACTION, reducerSetLoading), _defineProperty(_reduceMap, "notes", (_notes = {}, _defineProperty(_notes, NOTES_INSERT_ACTION, insertNote), _defineProperty(_notes, NOTES_SET_WITH_ALERT_ONLY_ACTION, notesSetWithAlertOnly), _defineProperty(_notes, NOTES_RECEIVED_ACTION, notesReceived), _defineProperty(_notes, NOTES_DELETE_ACTION, deleteNote), _defineProperty(_notes, NOTES_SET_NEW_NOTE_LOADING_ACTION, setNewNoteLoading), _defineProperty(_notes, NOTES_SET_ADDING_ACTION, notesSetAdding), _defineProperty(_notes, "newNote", (_newNote = {}, _defineProperty(_newNote, NOTES_UPDATE_NEW_NOTE_ACTION, updateNewNote), _defineProperty(_newNote, NOTES_ADD_FILE_NEW_NOTE_ACTION, addFileNewNote), _defineProperty(_newNote, NOTES_REMOVE_FILE_NEW_NOTE_ACTION, removeFileNewNote), _defineProperty(_newNote, NOTES_CLEAR_FILES_NEW_NOTE_ACTION, clearFilesNewNote), _newNote)), _defineProperty(_notes, NOTES_SET_NEW_PRIVATE_NOTE_LOADING_ACTION, setNewPrivateNoteLoading), _defineProperty(_notes, NOTES_SET_ADDING_PRIVATE_ACTION, notesSetAddingPrivate), _defineProperty(_notes, "newPrivateNote", (_newPrivateNote = {}, _defineProperty(_newPrivateNote, NOTES_UPDATE_NEW_PRIVATE_NOTE_ACTION, updateNewNote), _defineProperty(_newPrivateNote, NOTES_ADD_FILE_NEW_PRIVATE_NOTE_ACTION, addFileNewNote), _defineProperty(_newPrivateNote, NOTES_REMOVE_FILE_NEW_PRIVATE_NOTE_ACTION, removeFileNewNote), _defineProperty(_newPrivateNote, NOTES_CLEAR_FILES_NEW_PRIVATE_NOTE_ACTION, clearFilesNewNote), _newPrivateNote)), _notes)), _reduceMap);
var applicationReducer = createReducer(defaultState, reduceMap, objectActionHandler);
export default applicationReducer;